"use client";

import { useConsent } from "@shared/hooks/cookie-consent";
import { SecondaryCta } from "@repo/ui/components/design-system/cta/secondary-cta";
import { useTranslations } from "next-intl";

/**
 * Opens the CMP preferences dialog — used on legal pages (cookie & privacy policy).
 */
export function LegalConsentSettingsCta() {
	const { open } = useConsent();
	const t = useTranslations("cookies.policyPage");

	return (
		<div className="not-prose mb-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
			<SecondaryCta
				type="button"
				className="w-full sm:w-auto sm:min-w-[9rem]"
				ctaSize="small"
				onClick={() => open()}
			>
				{t("openSettingsCta")}
			</SecondaryCta>
		</div>
	);
}
